'use es6';

import { createTracker } from 'usage-tracker';
import events from 'analytics-tools-lib/events.yaml';
import * as ExperimentHelpers from 'analytics-tools-lib/lib/experimentHelpers';
const UsageTracker = createTracker({
  events,
  lastKnownEventProperties: ['subscreen'],
  properties: {
    namespace: 'reporting',
    screen: 'analytics'
  }
});
UsageTracker.trackDayZero = subscreen => {
  UsageTracker.track('analyticsToolDayZero', {
    action: 'analytics tool day zero',
    screen: `analytics-${subscreen}`
  });
};
UsageTracker.trackActivation = subscreen => {
  UsageTracker.track('analyticsToolActivation', {
    action: 'analytics tool activation',
    screen: `analytics-${subscreen}`
  });
  if (subscreen === 'sources') {
    ExperimentHelpers.trackSourceRetention();
  }
};
const BeaconTracker = UsageTracker.clone({
  properties: {}
});
const trackBeforeExit = screen => {
  BeaconTracker.track('exitPage', {
    action: 'analytics page exit',
    screen
  });
};
export { UsageTracker, BeaconTracker, trackBeforeExit };